import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatBot from "./components/ChatBot";
import GoogleAnalytics from "./components/GoogleAnalytics";
import Home from "./pages/Home";
import About from "./pages/About";
import Colleges from "./pages/Colleges";
import CollegeDetail from "./pages/CollegeDetail";
import Departments from "./pages/Departments";
import DepartmentDetail from "./pages/DepartmentDetail";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import Faculty from "./pages/Faculty";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import PublishedResearch from "./pages/PublishedResearch";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

// Admin imports
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Login from "./pages/admin/Login";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import NewsManagement from "./pages/admin/NewsManagement";
import RegistrationsManagement from "./pages/admin/RegistrationsManagement";
import GalleryManagement from "./pages/admin/GalleryManagement";
import ProgramsManagement from "./pages/admin/ProgramsManagement";
import CollegesManagement from "./pages/admin/CollegesManagement";
import PagesManagement from "./pages/admin/PagesManagement";
import SettingsManagement from "./pages/admin/SettingsManagement";
import SiteSettingsManagement from "./pages/admin/SiteSettingsManagement";
import FooterSettingsManagement from "./pages/admin/FooterSettingsManagement";
import DepartmentsManagement from "./pages/admin/DepartmentsManagement";
import FacultyManagement from "./pages/admin/FacultyManagement";
import LabsManagement from "./pages/admin/LabsManagement";
import FeaturesManagement from "./pages/admin/FeaturesManagement";
import CertificationsManagement from "./pages/admin/CertificationsManagement";
import PartnershipsManagement from "./pages/admin/PartnershipsManagement";
import ContactsManagement from "./pages/admin/ContactsManagement";
import ResearchManagement from "./pages/admin/ResearchManagement";
import AnnouncementsManagement from "./pages/admin/AnnouncementsManagement";

function App() {
  const [analyticsSettings, setAnalyticsSettings] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    // Fetch settings for Google Analytics
    fetch(`${BACKEND_URL}/api/settings/`)
      .then(res => res.json())
      .then(data => setAnalyticsSettings(data))
      .catch(err => console.error('Error fetching settings:', err));
  }, [BACKEND_URL]);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ThemeProvider>
          <AuthProvider>
            {/* Load Google Analytics & Search Console */}
            <GoogleAnalytics 
              measurementId={analyticsSettings?.google_analytics_id}
              searchConsoleCode={analyticsSettings?.google_search_console_code}
            />
            
            <Routes>
              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="announcements" element={<AnnouncementsManagement />} />
              <Route path="news" element={<NewsManagement />} />
              <Route path="gallery" element={<GalleryManagement />} />
              <Route path="programs" element={<ProgramsManagement />} />
              <Route path="colleges" element={<CollegesManagement />} />
              <Route path="departments" element={<DepartmentsManagement />} />
              <Route path="faculty" element={<FacultyManagement />} />
              <Route path="labs" element={<LabsManagement />} />
              <Route path="features" element={<FeaturesManagement />} />
              <Route path="certifications" element={<CertificationsManagement />} />
              <Route path="partnerships" element={<PartnershipsManagement />} />
              <Route path="contacts" element={<ContactsManagement />} />
              <Route path="research" element={<ResearchManagement />} />
              <Route path="pages" element={<PagesManagement />} />
              <Route path="settings" element={<SettingsManagement />} />
              <Route path="site-settings" element={<SiteSettingsManagement />} />
              <Route path="footer-settings" element={<FooterSettingsManagement />} />
              <Route path="registrations" element={<RegistrationsManagement />} />
            </Route>

            {/* Public Routes */}
            <Route path="*" element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/colleges" element={<Colleges />} />
                  <Route path="/colleges/:id" element={<CollegeDetail />} />
                  <Route path="/departments" element={<Departments />} />
                  <Route path="/departments/:slug" element={<DepartmentDetail />} />
                  <Route path="/programs" element={<Programs />} />
                  <Route path="/programs/:id" element={<ProgramDetail />} />
                  <Route path="/faculty" element={<Faculty />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="/research" element={<PublishedResearch />} />
                  <Route path="/published-research" element={<PublishedResearch />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/register" element={<Register />} />
                </Routes>
                <Footer />
                <ChatBot />
              </>
            } />
          </Routes>
          <Toaster />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </div>
);
}

export default App;
